import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
  SquaresFour, Briefcase, UserCircle, Receipt, Bell, SignOut, Wrench, FileText, UsersThree, DeviceMobile, ClipboardText,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/portal", label: "Dashboard", icon: SquaresFour, end: true },
  { to: "/portal/jobs", label: "My Jobs", icon: Briefcase },
  { to: "/portal/sell-pickups", label: "Sell Pickups", icon: DeviceMobile },
  { to: "/portal/sops", label: "Service SOPs", icon: ClipboardText },
  { to: "/portal/engineers", label: "My Engineers", icon: UsersThree },
  { to: "/portal/documents", label: "Documents", icon: FileText },
  { to: "/portal/ratecards", label: "Ratecards", icon: Receipt },
  { to: "/portal/notifications", label: "Notifications", icon: Bell },
  { to: "/portal/profile", label: "My Profile", icon: UserCircle },
];

export function PartnerLayout({ children }) {
  const { user, logout } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const fetchUnread = () =>
      api.get("/partner/dashboard").then((r) => setUnread(r.data.unread_notifications)).catch(() => {});
    fetchUnread();
    const t = setInterval(fetchUnread, 20000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="flex min-h-screen bg-background">
      <aside className="w-64 shrink-0 border-r border-border bg-card flex flex-col fixed h-screen" data-testid="partner-sidebar">
        <div className="h-16 flex items-center gap-2 px-6 border-b border-border">
          <div className="w-8 h-8 bg-primary rounded-sm flex items-center justify-center">
            <Wrench size={18} weight="bold" className="text-primary-foreground" />
          </div>
          <span className="font-heading font-bold text-lg tracking-tight">Fixigo</span>
          <span className="label-caps text-[9px] mt-1">Partner</span>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`pnav-${n.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) =>
                `flex items-center justify-between px-3 py-2.5 rounded-sm text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`
              }
            >
              <span className="flex items-center gap-3"><n.icon size={18} weight="bold" /> {n.label}</span>
              {n.label === "Notifications" && unread > 0 && (
                <span className="bg-destructive text-destructive-foreground text-[10px] font-bold rounded-full px-1.5 min-w-[18px] text-center" data-testid="notif-badge">{unread}</span>
              )}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-3">
          <div className="px-3 py-2 mb-1">
            <div className="text-sm font-semibold truncate" data-testid="partner-name">{user?.name}</div>
            <div className="text-xs text-muted-foreground uppercase tracking-wide">Partner</div>
          </div>
          <button data-testid="partner-logout" onClick={logout}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-sm text-sm font-medium text-destructive hover:bg-destructive/10 transition-colors duration-200">
            <SignOut size={18} weight="bold" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 min-w-0">{children}</main>
    </div>
  );
}
